import { connect } from 'react-redux'
import fetchUsers from '../sagas/fetchUsers'
import usersSelector from './usersSelector'
import {
  addArray as addUserArray
} from '../redux/users'
import Users from './Users'
import { withBoardContext } from 'dataProviders/Board'

const UsersConnected = connect(
  usersSelector,
  {
    fetchUsers,
    addUserArray
  }
)(Users)

UsersConnected.defaultProps = {
  onlyActive: true
}

export default withBoardContext(UsersConnected)
